import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { AccountingConfigurationListConfig } from './accounting-configurations-list.config';
import { SettingsModel } from 'src/app/core/models/system/settings.model';
import { AccountingConfigurationsModel } from 'src/app/core/models/accounting/account-settings.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { AccountingConfigurationModalService } from 'src/app/core/services/modal-services/accounting-configuration-modal.service';
import { Subscription } from 'rxjs';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-accounting-configurations-list',
  templateUrl: './accounting-configurations-list.component.html',
  styleUrls: ['./accounting-configurations-list.component.scss']
})
export class AccountingConfigurationsListComponent extends ListLayoutExtendableComponent implements OnChanges {

  @Input() public settingsModel: SettingsModel = new SettingsModel();
  @Output() public updateSettings = new EventEmitter<any>;

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  constructor(
    private accountingConfigurationService: AccountingConfigurationModalService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override openModalService: OpenModalService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  protected override searchPlaceHolderText: string = '';

  openAccountingConfigurationModal(model: AccountingConfigurationsModel, index: number | undefined) {
    this.accountingConfigurationService.openModal(model, index);
    var sub: Subscription = this.accountingConfigurationService.modelChanged.subscribe((result: any) => {
      if (index !== undefined) {
        this.settingsModel.accountingConfigurations[index] = result;
      } else {
        this.settingsModel.accountingConfigurations.push(result);
      }
      this.updateSettings.emit(this.settingsModel);
      sub.unsubscribe();
    })
  }



  ngOnChanges(changes: SimpleChanges) {
    this.tableConfig = new AccountingConfigurationListConfig();
    this.listItems = Object.assign([], this.settingsModel.accountingConfigurations);
  }

  override rowActionSelected(rowAction: TableActionsModel): void {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openAccountingConfigurationModal(rowAction.model, rowAction.index);
        break;
      case ActionIdEnum.Delete:
        if (rowAction.model == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.settingsModel.accountingConfigurations.splice(rowAction.index!, 1);
        this.updateSettings.emit(this.settingsModel);
        break;
    }
  }

  override buttonActionSelected(buttonAction: any): void {
    switch (buttonAction) {
      case ButtonIdEnum.CreateNew:
        this.openAccountingConfigurationModal(new AccountingConfigurationsModel, undefined);
        break;
      case ButtonIdEnum.Delete:
        this.deleteMultiple();
        break;
    }
  }

  deleteMultiple() {
    var checkboxes: any = document.getElementsByName('checkAll');
    var result
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }
    if (checkedVal.length > 0) {
      Swal.fire({
        title: $localize`:@@:Delete Multiple Accounting Configuration`,
        text: $localize`:@@:Are you sure you want to delete these configurations?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          for (var i = 0; i < checkedVal.length; i++) {
            this.settingsModel.accountingConfigurations.splice(checkedVal[i], 1);
          }
          this.updateSettings.emit(this.settingsModel);
        }
      });
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select a Configuration',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }

    this.checkedValGet = checkedVal;
  }

  //No Filters on this list - Still must implement something since by default it is abstract for all other lists. 
  override filterSelected(filterSelected: ListFilterModel): void {
    // Nothing Since no filters in config
  }
  override ngOnInit(): void {

  }
  override ngOnDestroy(): void {
  
  }
}
